module.exports = __webpack_public_path__ + "media/images/vp/samples/12-db60495344ca0e07d8089f2910a5b293.jpg";